import { ProviderField } from '../../models/provider';

export const parseFieldsWithAdditionalInfo = (fields: ProviderField[]) => {
  const newFields = fields.map((field) => {
    if (field.additionalInfo && typeof field.additionalInfo === 'string') {
      return {
        ...field,
        additionalInfo: JSON.parse(field.additionalInfo),
      };
    }

    return field;
  });

  return newFields;
};

export const parseSupplementalInformation = (jsonString?: string) => {
  const providerFields: ProviderField[] = JSON.parse(jsonString || '[]');
  const providerFieldsWithParsedAdditionalInfo = parseFieldsWithAdditionalInfo(providerFields);

  return providerFieldsWithParsedAdditionalInfo;
};
